export default __webpack_public_path__ + "static/media/clock-grey.57363f94.svg";